import { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { ElasticFormModal } from 'basic-components';
import { DataScienceEnums } from 'dashboard-services/api/dataScience';

import Param from './Param';

import './ParametersModal.scss';

const EMPTY_OBJ = {};
const EMPTY_ARRAY = [];
const ParametersModal = ({ onClose, onSubmit, defaultTaskParams = EMPTY_ARRAY, taskId = undefined }) => {
  const [taskParams, setTaskParams] = useState(defaultTaskParams),
        taskName = useSelector(state => {
          const selectedTask = state.datascienceState.creatorState.builderState.tasks[taskId] || EMPTY_OBJ
          return selectedTask.readableName
        }),
        selectedParamsAsObject = useMemo(() => Object.fromEntries((taskParams || EMPTY_OBJ).map(p => [p.name, p.value])), [taskParams]),
        getAllParams = useCallback(() => selectedParamsAsObject, [selectedParamsAsObject]),
        onChange = useCallback((value, name, paramIndex) => {
          setTaskParams(tp => tp.updateInList({ [name]: value }, paramIndex))
        }, []),
        onSubmitLocal = useCallback(() => {
          onSubmit(taskParams)
          onClose()
        }, [onClose, onSubmit, taskParams])
  return (
    <ElasticFormModal
        className="ng-python-editor__parameters"
        onClose={onClose}
        onSubmit={onSubmitLocal}
        title="Sandbox Parameters"
    >
      {taskParams.map((param, paramIndex) => {
        if(param.type === DataScienceEnums.TASK_PARAM_TYPE.OUTPUT) {
          return null;
        }
        return (
          <Param
              getAllParams={getAllParams}
              key={paramIndex}
              onChange={onChange}
              param={param}
              paramIndex={paramIndex}
              taskName={taskName}
              taskParams={taskParams}
          />
        )
      })}
    </ElasticFormModal>
  )
}

ParametersModal.propTypes = {
  defaultTaskParams: PropTypes.array,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  taskId: PropTypes.string,
}

export default ParametersModal;